module.exports = __webpack_public_path__ + "oauth_login.css";